import React from 'react';
import PropTypes from 'prop-types';
import UploadDocument from './uploadDocument';

export default function UploadExcelFile({
  selectedFiles,
  setSelectedFiles,
  onUpload,
  attachment,
  Width,
  getLoaderStatus,
  setDocData,
  limit,
  label,
}) {
  return (
    <UploadDocument
      selectedFiles={selectedFiles}
      setSelectedFiles={setSelectedFiles}
      onUpload={onUpload}
      attachment={attachment}
      getLoaderStatus={getLoaderStatus}
      setDocData={setDocData}
      Width={Width}
      multiple={false}
      label={label}
      acceptType=".xlsx"
      limit={limit || 1}
      // ExcelDownload
    />
  );
}

UploadExcelFile.propTypes = {
  selectedFiles: PropTypes.instanceOf(Array),
  setSelectedFiles: PropTypes.func,
  onUpload: PropTypes.func,
  Width: PropTypes.string,
  getLoaderStatus: PropTypes.func,
  setDocData: PropTypes.func,
  limit: PropTypes.number,
  label: PropTypes.string,
  attachment: PropTypes.instanceOf(Object),
};
UploadExcelFile.defaultProps = {
  attachment: [],
  selectedFiles: [],
  setSelectedFiles: () => {},
  onUpload: () => {},
  Width: '',
  getLoaderStatus: () => {},
  setDocData: () => {},
  limit: 1,
  label: '',
};
